// src/features/dashboard/admin/StatCard.jsx
import React from 'react';

export const StatCard = ({ title, value, color, icon }) => (
  <div className={`p-4 ${color} text-white rounded-lg shadow flex items-center`}>
    <div className="mr-3 text-3xl">{icon}</div>
    <div>
      <h2 className="text-sm font-medium opacity-80">{title}</h2>
      <p className="text-2xl font-bold">{value}</p>
    </div>
  </div>
);